import React, { useState } from "react";

import { clientUrl } from "../../constants/site-urls";
import Tabs from "../tabs";

const TemplatePreview = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="mx-auto max-w-7xl pb-16 px-6 lg:px-8">
      <div>
        <h2 className="text-base font-semibold leading-7 text-emerald-600">
          Starter templates
        </h2>
        <p className="mt-2 max-w-2xl text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
          A variety of starting points, so you can hit the ground running
        </p>
        <p className="mt-4 max-w-xl text-base leading-8 text-slate-600">
          Starter templates include a wide variety of common extension starting
          points and patterns so you can pick one and get started without
          worrying about boilerplate code ever again
        </p>
        <a
          className="mt-4 inline-block font-semibold text-emerald-500 hover:text-emerald-700"
          href={`${clientUrl}/?ref=preview`}
        >
          View all templates &rarr;
        </a>
      </div>
      <div className="mt-16">
        <Tabs activeTab={activeTab} setActiveTab={setActiveTab} />
      </div>
    </div>
  );
};

export default TemplatePreview;
